import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';

export interface UploadedDocument {
  pkStudentDocumentsId: number;
  documentTitle: string;
  documentTypeName: string;
  createdOn: string;
  createdBy: string;
  fileType: string;
  documentUrl: string;
}

// Document Hub — parent mobile app's own endpoint (see the API reference
// this was built from). Single call, no pagination/server-side filtering —
// the whole list is fetched once and searched/filtered client-side.
@Injectable({ providedIn: 'root' })
export class ParentDocumentHubService {

  private base = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) { }

  private authHeaders(): HttpHeaders | undefined {
    const raw = localStorage.getItem('authToken');
    if (!raw) { return undefined; }
    try {
      return new HttpHeaders().append('authToken', JSON.parse(raw));
    } catch {
      return new HttpHeaders().append('authToken', raw);
    }
  }

  getUploadedDocuments(lang: string) {
    return this.http.get(`${this.base}/student/profile/view/uploaded/documents/for/parent`, {
      params: { lang },
      headers: this.authHeaders(),
    });
  }
}
